import React from "react";

import styled from "styled-components/macro";

import { useMediaSettings } from "Signups/stateHooks";
import { motion } from "framer-motion";

import { getVideoSource } from "Utilities/VideoUtils";

import { animate, initial } from "../animation";

export function SignupVideo(props) {
  const { mediaSettings } = useMediaSettings();
  const { videoUrl } = mediaSettings;

  const videoSource = getVideoSource(videoUrl);

  const urlWithSearchParams =
    videoSource === "youtube"
      ? `${videoUrl}?controls=0&iv_load_policy=3&enablejsapi=1`
      : videoUrl;

  return (
    <VideoWrapper
      initial={initial}
      animate={{...animate, transition: { ...animate.transition, delay: 0.1 }}}
      data-cy="public-signup-video"
    >
      <VideoFrame
        src={urlWithSearchParams}
        title="video player"
        allow="picture-in-picture;"
        allowFullScreen
      />
    </VideoWrapper>
  );
}

const VideoWrapper = styled(motion.div)`
  width: 100%;
  margin-block-end: 1.5rem;
  aspect-ratio: 16/9;
  border-radius: 0.625rem;
  box-shadow: rgba(0, 0, 0, 0.6) 1px 1px 12px;
  cursor: pointer;
`;

const VideoFrame = styled.iframe`
  border-radius: 6px;
  overflow: hidden;

  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: none;
  display: block;
`;